import React from 'react'
import CollectionAsset from './CollectionAsset'
import ProfileNav from './ProfileNav'

function OnSale() {
    return (
        <div className="CollectionAsset">
        <CollectionAsset
            ImageThumb = "https://ipfs.pixura.io/ipfs/QmPoLy64sYYQgESPC3pQyovATguadz9vh3Jg65WTFeiyi9"
            Price = {4.89}
            Like = {453}
        />
        <CollectionAsset
            ImageThumb = "https://ipfs.pixura.io/ipfs/QmPoLy64sYYQgESPC3pQyovATguadz9vh3Jg65WTFeiyi9"
            Price = {4.89}
            Like = {453}
        />
        <CollectionAsset
            ImageThumb = "https://ipfs.pixura.io/ipfs/QmPoLy64sYYQgESPC3pQyovATguadz9vh3Jg65WTFeiyi9"
            Price = {4.89}
            Like = {453}
        />
        <CollectionAsset
            ImageThumb = "https://ipfs.pixura.io/ipfs/QmPoLy64sYYQgESPC3pQyovATguadz9vh3Jg65WTFeiyi9"
            Price = {4.89}
            Like = {453}
        />
        <CollectionAsset
            ImageThumb = "https://ipfs.pixura.io/ipfs/QmPoLy64sYYQgESPC3pQyovATguadz9vh3Jg65WTFeiyi9"
            Price = {4.89}
            Like = {453}
        />
        </div>
    )
}

export default OnSale
